import React, { useEffect, useRef } from 'react';
import { ActivityFilterValue, FilterOption } from '../../services/admin/userActivity/activity.model';
interface Props {
  isOpen: boolean;
  onClose: () => void;
  value: ActivityFilterValue;
  onChange: (v: ActivityFilterValue) => void;
  options: FilterOption[];
}

const UserActivityLogFilter: React.FC<Props> = ({
  isOpen,
  onClose,
  value,
  onChange,
  options,
}) => {
  const dropdownRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleClickOutside = (ev: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(ev.target as Node)
      ) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) {
    return null;
  }

  return (
    <div className="filter-dropdown" ref={dropdownRef}>
      <div className="filter-dropdown__content">
        <h4 className="filter-dropdown__title">Filter Activity</h4>

        <div className="filter-dropdown__checkbox-group">
          {options.map(option => (
            <label
              key={option.value}
              className="filter-dropdown__checkbox-label"
            >
              <input
                type="radio"
                name="activityType"
                checked={value === option.value}
                onMouseDown={e => { e.preventDefault(); }}
                onClick={() => {
                  const y = typeof window !== 'undefined' ? window.scrollY : 0;
                  onChange(option.value);
                  onClose();
                  setTimeout(() => { try { window.scrollTo(0, y); } catch (_) {} }, 0);
                }}
                onChange={() => {
                  const y = typeof window !== 'undefined' ? window.scrollY : 0;
                  onChange(option.value);
                  onClose();
                  setTimeout(() => { try { window.scrollTo(0, y); } catch (_) {} }, 0);
                }}
              />
              <span className="filter-dropdown__checkbox-text">
                {option.label}
              </span>
            </label>
          ))}
        </div>
      </div>
    </div>
  );
};

export default UserActivityLogFilter;
